import { createSlice } from '@reduxjs/toolkit';
import {
  fetchOpsInitStateCreator,
  fetchPendingReducersCreator,
  fetchRejectedReducersCreator,
  fetchResetReducersCreator,
} from '../../utils/helpers/fetchReducerHelpers';
import { getPhaseConfigConstants, updatePhaseConfigConstants } from '../constants/phasesConstants';
import { PHASES_DOMAIN_NAME } from '../constants/constants';

const DEFAULT_PHASES = [
  {
    key: 'application', label: 'Application Review', order: 0, isFixed: true,
  },
  {
    key: 'screening_interview', label: 'Screening Interview', order: 1, isFixed: true,
  },
  {
    key: 'decision', label: 'Decision', order: 2, isFixed: true,
  },
];

const opNames = ['getPhaseConfig', 'updatePhaseConfig'];
const actionNames = [getPhaseConfigConstants, updatePhaseConfigConstants];

const fetchOps = fetchOpsInitStateCreator(opNames);
const fetchPendingReducers = fetchPendingReducersCreator(actionNames, opNames, 'fetchOps');
const fetchRejectedReducers = fetchRejectedReducersCreator(actionNames, opNames, 'fetchOps');
const fetchResetReducers = fetchResetReducersCreator(actionNames, opNames, 'fetchOps');

const phasesSlice = createSlice({
  name: PHASES_DOMAIN_NAME,
  initialState: {
    phases: DEFAULT_PHASES,
    fetchOps,
  },
  extraReducers: {
    ...fetchPendingReducers,
    ...fetchRejectedReducers,
    ...fetchResetReducers,
    [getPhaseConfigConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.getPhaseConfig.status = 'succeeded';
      state.fetchOps.getPhaseConfig.error = null;
      state.phases = payload;
    },
    [updatePhaseConfigConstants.fulfilled]: (state, { payload }) => {
      state.fetchOps.updatePhaseConfig.status = 'succeeded';
      state.fetchOps.updatePhaseConfig.error = null;
      state.phases = payload;
    },
  },
});

export default phasesSlice.reducer;
